import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FilterStateService {

    private filterState = new BehaviorSubject<FilterState>(
        new FilterState(),
    );

    public get observeState$(): Observable<FilterState> {
        return this.filterState.asObservable(); 
    }

    public storeState(fs?: FilterState) {
        this.filterState.next(fs || new FilterState());
    }
}

export class FilterState {
    public year: string | null;
    public types: string[] | null;
    public status: string[] | null;

    constructor(
        aYear: string | null = null,
        someTypes: string[] | null = null,
        status: string[] | null = null,
    ) {
        this.year = aYear;
        this.types = someTypes;
        this.status = status;
    }
}
